import { useEffect } from 'react';
import { reportAuthError } from '~/common/reportAuthError';
import { useQuery } from '~/common/routerUtils';
import authStore from '../../authStore';

export default function SSOLogin() {
  const query = useQuery();

  useEffect(() => {
    const jwt = query.get('jwt');
    const redirectUri = query.get('redirectUri');

    if (jwt) {
      authStore.setToken(jwt, redirectUri || undefined);
    } else {
      // The IdP redirected back here without a JWT — a real SSO fault, report it on the auth page.
      console.error('token not found');
      reportAuthError(new Error('SSO callback reached without a JWT'), {
        context: 'auth:sso:missingToken',
        step: 'ssoCallback',
        metadata: { hasRedirectUri: Boolean(redirectUri) },
      });
    }
  }, [query]);

  return null;
}
